import { Box, Fade, styled } from "@mui/material";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import ClientProvider from "../../../../modules/ClientProvider";
import { useDealContext } from "../../../deal/context";
import { AdvisorGridItem } from "./AdvisorGridItem";
import { IProject, IAdvisor, ICompany, IProfile } from "../../../../types";
import { useUserContext } from "../../../users";


const defaultIconSvg = '<svg fill="#ffffff" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64px" height="64px" viewBox="-128.38 -128.38 750.52 750.52" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="-128.38" y="-128.38" width="750.52" height="750.52" rx="375.26" fill="#b9b9b9" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g id="Icons_15_"> <g> <path d="M290.652,402.646h-87.595c-6.781,0-12.283,5.503-12.283,12.283c0,6.785,5.502,12.287,12.283,12.287h87.595 c6.781,0,12.289-5.502,12.289-12.287C302.942,408.149,297.435,402.646,290.652,402.646z"></path> <path d="M224.299,474.245c1.666,11.026,11.086,19.517,22.586,19.517c11.488,0,20.93-8.487,22.589-19.517 c15.037-0.888,26.987-13.245,26.987-28.504H197.25C197.25,461.009,209.235,473.375,224.299,474.245z"></path> <path d="M246.884,70.87c9.062,0,16.387-7.335,16.387-16.381V16.381C263.271,7.332,255.947,0,246.884,0 c-9.053,0-16.377,7.332-16.377,16.381v38.108C230.508,63.535,237.832,70.87,246.884,70.87z"></path> <path d="M139.39,94.736c3.217,4.417,8.209,6.761,13.283,6.761c3.326,0,6.699-1.017,9.609-3.129 c7.313-5.312,8.945-15.555,3.633-22.873l-22.396-30.84c-5.326-7.312-15.549-8.96-22.887-3.632 c-7.311,5.309-8.943,15.555-3.631,22.873L139.39,94.736z"></path> <path d="M354.354,334.861c-5.313-7.312-15.549-8.934-22.881-3.621c-7.306,5.317-8.937,15.562-3.61,22.879l22.409,30.841 c3.196,4.407,8.188,6.753,13.265,6.753c3.338,0,6.698-1.017,9.608-3.128c7.312-5.319,8.942-15.565,3.619-22.884L354.354,334.861 z"></path> <path d="M99.502,149.684l-36.252-11.79c-8.686-2.799-17.846,1.911-20.648,10.518c-2.803,8.597,1.904,17.843,10.508,20.642 l36.252,11.79c1.693,0.544,3.387,0.809,5.066,0.809c6.91,0,13.324-4.4,15.582-11.327 C112.812,161.729,108.106,152.482,99.502,149.684z"></path> <path d="M440.649,260.538l-36.243-11.773c-8.611-2.778-17.841,1.918-20.638,10.516c-2.802,8.606,1.918,17.848,10.521,20.646 l36.252,11.772c1.681,0.545,3.373,0.807,5.054,0.807c6.909,0,13.323-4.407,15.581-11.324 C453.971,272.572,449.258,263.337,440.649,260.538z"></path> <path d="M89.375,248.765L53.11,260.522c-8.604,2.79-13.324,12.026-10.521,20.635c2.238,6.927,8.664,11.334,15.574,11.334 c1.668,0,3.381-0.267,5.061-0.811l36.258-11.756c8.611-2.792,13.33-12.03,10.529-20.635 C107.229,250.689,98.059,245.986,89.375,248.765z"></path> <path d="M399.35,181.653c1.681,0,3.373-0.265,5.056-0.809l36.243-11.773c8.608-2.799,13.322-12.039,10.526-20.642 c-2.803-8.6-12.077-13.3-20.635-10.518l-36.252,11.772c-8.604,2.798-13.322,12.038-10.521,20.642 C386.02,177.246,392.44,181.653,399.35,181.653z"></path> <path d="M139.412,334.855l-22.431,30.822c-5.326,7.318-3.707,17.563,3.619,22.883c2.896,2.119,6.27,3.138,9.609,3.138 c5.074,0,10.066-2.336,13.264-6.744l22.43-30.824c5.326-7.316,3.707-17.562-3.619-22.883 C154.991,325.898,144.702,327.538,139.412,334.855z"></path> <path d="M350.258,44.654l-22.396,30.84c-5.312,7.318-3.681,17.562,3.633,22.873c2.91,2.112,6.283,3.129,9.608,3.129 c5.074,0,10.065-2.343,13.276-6.761l22.396-30.841c5.311-7.318,3.68-17.564-3.634-22.873 C365.786,35.68,355.584,37.326,350.258,44.654z"></path> <path d="M365.194,215.404c0-65.354-52.976-118.333-118.322-118.333c-65.359,0-118.336,52.979-118.336,118.333 c0,27.569,9.482,52.884,25.322,72.981c13.881,17.612,27.027,36.839,38.42,56.187v39.306h108.516v-38.263 c11.288-18.818,25.881-40.484,39.065-57.211C355.713,268.301,365.194,242.991,365.194,215.404z"></path> </g> </g> </g> </g> </g></svg>';

const gridStyle = {
    display: "grid",
    gridTemplateRows: "auto auto",
    gridAutoFlow: "column",
    overflowX: "auto",
    gap: "1rem",
    padding: "1rem",
    justifyContent: "flex-start",
    alignItems: "flext-start"
};


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
    },
}));


export const AdvisorLeads = ({ project }: { project: IProject }) => {
    // State for leads and display
    const [displayedLeads, setDisplayedLeads] = useState<any[]>([]);
    const [fadingIndex, setFadingIndex] = useState<number | null>(null);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState<string | null>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);
    const containerRef = useRef<HTMLDivElement>(null);


    // Refs for tracking state
    const displayedLeadUuids = useRef<Set<string>>(new Set());
    const noNewLeadsCount = useRef<number>(0);
    const isFetching = useRef<boolean>(false);
    const shouldStopFetching = useRef<boolean>(false);
    const currentLeadsRef = useRef<any[]>([]);
    const allLeadsRef = useRef<any[]>([]);

    // Timer refs
    const fetchTimer = useRef<NodeJS.Timeout>();
    const rotationTimer = useRef<NodeJS.Timeout>();
    const progressTimer = useRef<NodeJS.Timeout>();

    const { getAccessTokenSilently } = useAuth0();
    const { dealContext } = useDealContext();
    const { userContext } = useUserContext();
    const user = userContext?.dbUser;

    // Add effect to set initial container width
    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }
    }, []);

    const getNumLeadsToDisplay = () => {
        const numColumns = (containerWidth - containerWidth%130)/130;
        return numColumns * 2;
    };

    // Cleanup function for timers
    const cleanupTimers = () => {
        if (fetchTimer.current) clearTimeout(fetchTimer.current);
        if (rotationTimer.current) clearInterval(rotationTimer.current);
        if (progressTimer.current) clearInterval(progressTimer.current);
    };

    // Fetch leads from the API
    const fetchLeads = async () => {
        if (isFetching.current || shouldStopFetching.current) return;

        isFetching.current = true;
        try {
            const accessToken = await getAccessTokenSilently();
            const client = ClientProvider.provideProjectClient();
            const { data, error } = await client.getLeadsData(project.id, accessToken);

            if (error) {
                setError(error.message);
                return;
            }

            if (!data?.leads) {
                noNewLeadsCount.current++;
                if (noNewLeadsCount.current >= 5) {
                    shouldStopFetching.current = true;
                }
                return;
            }

            // Filter out leads we've already seen
            const newLeads = data.leads.filter((lead: any) => !allLeadsRef.current.some((l: any) => l.uuid === lead.uuid));

            if (newLeads.length === 0) {
                noNewLeadsCount.current++;
                if (noNewLeadsCount.current >= 5) {
                    shouldStopFetching.current = true;
                }
            } else {
                noNewLeadsCount.current = 0;
                allLeadsRef.current = [...allLeadsRef.current, ...newLeads];
            }
        } catch (err) {
            setError(err instanceof Error ? err.message : 'An error occurred');
        } finally {
            isFetching.current = false;
        }
    };

    // Initialize the display with up to 12 leads
    const initializeDisplay = () => {
        if (currentLeadsRef.current.length >= getNumLeadsToDisplay()) return;

        const availableLeads = allLeadsRef.current.filter(lead => !displayedLeadUuids.current.has(lead.uuid));
        const leadsToAdd = availableLeads.slice(0, getNumLeadsToDisplay() - currentLeadsRef.current.length);

        if (leadsToAdd.length > 0) {
            setDisplayedLeads(prev => {
                const newLeads = [...prev, ...leadsToAdd];
                currentLeadsRef.current = newLeads;
                return newLeads;
            });
            leadsToAdd.forEach(lead => displayedLeadUuids.current.add(lead.uuid));
        }
        setTimeout(() => { fetchLeads(); }, 5000);
    };

    // Initial setup and cleanup
    useEffect(() => {
        // Start progress bar animation
        progressTimer.current = setInterval(() => {
            setProgress(old => {
                if (old === 100) return 100;
                const diff = Math.random() * 10;
                return Math.min(old + diff, 100);
            });
        }, 2000);

        // Initial fetch
        fetchLeads();

        // Set up rotation interval
        rotationTimer.current = setInterval(() => {
            const currentNumLeads = getNumLeadsToDisplay();
            if (currentLeadsRef.current.length < currentNumLeads) {
                initializeDisplay();
                return;
            }

            const availableLeads = allLeadsRef.current.filter(lead => !displayedLeadUuids.current.has(lead.uuid));
            if (availableLeads.length === 0) {
                // If we've used all leads, try fetching more
                if (!shouldStopFetching.current) {
                    fetchLeads();
                }
                return;
            }

            // Pick a random position to replace
            const positionToReplace = Math.floor(Math.random() * currentNumLeads);
            const newLead = availableLeads[Math.floor(Math.random() * availableLeads.length)];

            // Start fade out
            setFadingIndex(positionToReplace);

            // After fade out, update the lead
            setTimeout(() => {
                setDisplayedLeads(prev => {
                    const newLeads = [...prev];
                    newLeads[positionToReplace] = newLead;
                    currentLeadsRef.current = newLeads;
                    return newLeads;
                });
                displayedLeadUuids.current.add(newLead.uuid);
                setFadingIndex(null);
            }, 1000);
        }, 5000);

        return cleanupTimers;
    }, [containerWidth]);

    // Add resize observer effect
    useEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                setContainerWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(containerRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    // Update display when container width changes
    useEffect(() => {
        const currentNumLeads = getNumLeadsToDisplay();
        if (displayedLeads.length > currentNumLeads) {
            setDisplayedLeads(prev => prev.slice(0, currentNumLeads));
            currentLeadsRef.current = currentLeadsRef.current.slice(0, currentNumLeads);
        } else if (displayedLeads.length < currentNumLeads) {
            initializeDisplay();
        }
    }, [containerWidth]);

    // Update display when we get new leads
    useEffect(() => {
        if (displayedLeads.length < getNumLeadsToDisplay()) {
            initializeDisplay();
        }
        currentLeadsRef.current = displayedLeads;
    }, [displayedLeads]);

    return (
        <Fade in={true}>
            <Box ref={containerRef} className="display-box" sx={{ marginTop: "40px", overflow: "hidden", width: "100%" }}>
            {displayedLeads.length === 0 ? (
                    <>
                        <h5>Identifying executives in your ICP...</h5>
                        <BorderLinearProgress variant="determinate" value={progress} />
                    </>
                ) : (
                    <>
                        <h5>Identifying executives in your ICP...</h5>
                        <Box sx={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${getNumLeadsToDisplay()/2}, 1fr)`,
                            gap: "1rem",
                            padding: "1rem",
                        }}>
                            {Array.from({ length: getNumLeadsToDisplay() }).map((_, index) => {
                                const lead = displayedLeads[index];
                                if (!lead) return null;

                                const advisor = {
                                    uuid: lead.uuid,
                                    user: {
                                        uuid: lead.user_uuid as string,
                                        profile: {
                                            name: lead.name as string,
                                            title: lead.title as string,
                                            company_name: lead.company_name as string,
                                            image_url: lead.image_url as string,
                                            linkedin_url: lead.linkedin_url as string,
                                            company: {
                                                name: lead.company_name as string,
                                            } as ICompany
                                        } as IProfile
                                    }
                                } as IAdvisor;

                                return (
                                    <Box key={`${lead.uuid}-${index}`} sx={{ 
                                        opacity: fadingIndex === index ? 0 : 1,
                                        transition: 'opacity 1s ease-in-out'
                                    }}>
                                        <AdvisorGridItem advisor={advisor} user={user} style="face-grid" isVisible={true} type="lead" />
                                    </Box>
                                );
                            })}
                        </Box>
                    </>
                )}
            </Box>
        </Fade>
    );
}